import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from "@ionic/react";

import iconDisclosureDown from "../assets/Button_Disclosure_Down_Blue@3x.png";
import iconDisclosureDownDark from "../assets/Button_Disclosure_Down_Blue_Dark@3x.png";
import iconDisclosureUp from "../assets/Button_Disclosure_Up_Blue@3x.png";
import iconDisclosureUpDark from "../assets/Button_Disclosure_Up_Blue_Dark@3x.png";

import guidelineIcon from "../assets/Icon_Search_Guidelines@3x.png";
import trustGuidelineIcon from "../assets/Icon_Search_Trust@3x.png";
import medIcon from "../assets/Icon_Search_Meds@3x.png";
import algorithmIcon from "../assets/Icon_Search_Algorithms@3x.png";
import pageForAgeIcon from "../assets/Icon_Search_PageforAge@3x.png";
import clinicalNoticeIcon from "../assets/Icon_Search_CNs@3x.png";
import pathwayIcon from "../assets/Icon_Search_Pathways@3x.png";
import essentialsIcon from "../assets/Icon_Search_Essentials@3x.png";
import furtherResourceIcon from "../assets/Icon_Search_Further_Resources@3x.png";

import guidelineIconDark from "../assets/Icon_Search_Guidelines_Dark@3x.png";
import trustGuidelineIconDark from "../assets/Icon_Search_Trust_Dark@3x.png";
import medIconDark from "../assets/Icon_Search_Meds_Dark@3x.png";
import algorithmIconDark from "../assets/Icon_Search_Algorithms_Dark@3x.png";
import pageForAgeIconDark from "../assets/Icon_Search_PageforAge_Dark@3x.png";
import clinicalNoticeIconDark from "../assets/Icon_Search_CNs_Dark@3x.png";
import pathwayIconDark from "../assets/Icon_Search_Pathways_Dark@3x.png";
import essentialsIconDark from "../assets/Icon_Search_Essentials_Dark@3x.png";
import furtherResourceIconDark from "../assets/Icon_Search_Further_Resource_Dark@3x.png";

import "../Shared.css";
import "../../App.css";
import "./FilterChip.css";

type Props = {
  name: string;
  selected: boolean;
  darkMode: boolean;
  onClick: (value: string) => void;
};
type State = {};

class FilterChip extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let iconSrc = "";

    if (this.props.name === "Guideline") {
      iconSrc = this.props.selected || this.props.darkMode ? guidelineIconDark : guidelineIcon;
    } else if (this.props.name === "Medicine") {
      iconSrc = this.props.selected || this.props.darkMode ? medIconDark : medIcon;
    }
    if (this.props.name === "Algorithm") {
      iconSrc = this.props.selected || this.props.darkMode ? algorithmIconDark : algorithmIcon;
    } else if (this.props.name === "Clinical Notice") {
      iconSrc = this.props.selected || this.props.darkMode ? clinicalNoticeIconDark : clinicalNoticeIcon;
    } else if (this.props.name === "Essentials") {
      iconSrc = this.props.selected || this.props.darkMode ? essentialsIconDark : essentialsIcon;
    } else if (this.props.name === "Further Resource") {
      iconSrc = this.props.selected || this.props.darkMode ? furtherResourceIconDark : furtherResourceIcon;
    } else if (this.props.name === "Pathway") {
      iconSrc = this.props.selected || this.props.darkMode ? pathwayIconDark : pathwayIcon;
    }

    return (
      <div
        className={`filterChip ${this.props.selected ? "filterChipSelected" : ""}`}
        onClick={this.props.onClick.bind(this, this.props.name)}
      >
        {iconSrc !== "" ? <img className="filterChipIcon" src={iconSrc} alt="" /> : null}
        <div>{this.props.name}</div>
      </div>
    );
  }
}

export default FilterChip;
